import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import LogList from './LogList';
import { useParams } from 'react-router-dom';

const initialPageSize = 25;

const LogsByRuleId = () => {
  const dispatch = useDispatch();
  const { rule_id } = useParams();
  const { logs, loadingLogs, loadingMoreLogs } = useSelector((state) => state.general);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(initialPageSize);
  const [logType, setLogType] = useState('FULL_RULE');

  const fetchLogs = () => {
    dispatch(generalSet({ reduxField: 'loadingLogs', value: true }));
    dispatch(
      apiAction({
        reduxField: 'logs',
        route: 'logs/getLogsByRuleId',
        page,
        size,
        logType,
        ruleId: rule_id,
        setLoading: 'loadingLogs',
      })
    );
  };

  useEffect(() => {
    fetchLogs();
  }, [dispatch, page, size]);

  console.log({ logs });

  return Array.isArray(logs) ? (
    <div className='mb-5'>
      <LogList
        logs={logs}
        logType={logType}
        setLogType={setLogType}
        fetchLogs={fetchLogs}
        loadingLogs={loadingLogs}
        ruleId={rule_id}
      />
      <div className='mt-4 d-flex justify-content-center'>
        <button
          className='btn btn-outline-primary'
          disabled={loadingMoreLogs}
          onClick={() => {
            setPage((prevPage) => prevPage + 1);
            dispatch(generalSet({ reduxField: 'loadingMoreLogs', value: true }));
            dispatch(
              apiAction({
                reduxField: 'logs',
                route: 'logs/getLogsByRuleId',
                page,
                size,
                logType,
                ruleId: rule_id,
                setLoading: 'loadingMoreLogs',
                addArrayToArray: true,
              })
            );
          }}
        >
          Load {initialPageSize} More
        </button>
      </div>
    </div>
  ) : (
    <Spinner />
  );
};

export default LogsByRuleId;
